import React from 'react';
import { Button } from '@/components/ui/button';
import { MessageCircle } from 'lucide-react';
import { useFeedback } from './FeedbackContext';
import { FeedbackContextData } from './types';

interface FeedbackButtonProps {
  children?: React.ReactNode;
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link" | "thalo";
  size?: "default" | "sm" | "lg";
  feature?: string;
  description?: string;
  className?: string;
}

export const FeedbackButton: React.FC<FeedbackButtonProps> = ({
                                                                children,
                                                                variant = "thalo",
                                                                size = "default",
                                                                feature,
                                                                description,
                                                                className,
                                                                ...props
                                                              }) => {
  const { openFeedback } = useFeedback();

  const handleClick = (): void => {
    const context: FeedbackContextData | undefined = feature ? { feature, description } : undefined;
    openFeedback(context);
  };

  return (
    <Button
      variant={variant}
      size={size}
      onClick={handleClick}
      className={className}
      {...props}
    >
      {children || (
        <>
          <MessageCircle className="h-4 w-4 mr-2" />
          Feedback
        </>
      )}
    </Button>
  );
};